// Antiforgery (CSRF) token handling for the signing API.
//
// The signing endpoints under /api/documents validate an antiforgery token on
// every POST. We fetch the token once from the anonymous token endpoint (which
// also sets the matching cookie on the same origin) and reuse it for the life
// of the component. The fetch is lazy and cached via a single promise so that
// concurrent callers share one request.

let tokenPromise = null

function ensureToken(baseUrl) {
    if (!tokenPromise) {
        tokenPromise = fetch(`${baseUrl}/documents/antiforgery-token`)
            .then(res => (res.ok ? res.json() : { token: '' }))
            .then(data => data.token)
            .catch(err => {
                // Reset so a later POST can retry obtaining the token.
                tokenPromise = null
                console.error('Failed to fetch antiforgery token', err)
                return ''
            })
    }

    return tokenPromise
}

// Build the headers for a JSON POST, including the antiforgery token.
export async function postHeaders(baseUrl) {
    const token = await ensureToken(baseUrl)

    return {
        'Content-Type': 'application/json',
        'Chq-Antiforgery-Token': token
    }
}
